import { render, staticRenderFns } from "./DetailNews.vue?vue&type=template&id=9012d9ee&"
import script from "./DetailNews.vue?vue&type=script&lang=js&"
export * from "./DetailNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports